import axios from 'axios'

const request = axios.create({
  // 测试环境
  // baseURL: 'http://test-9game.laolongtang.com.cn'

  // 生产环境
  baseURL: 'http://9game.laolongtang.com.cn'
})
export default request
